import GroupChevron from "../GroupChevron";
import CellCheckbox from "../CellCheckbox";
import CellFavorite from "../CellFavorite";
import Children from "./Children";
import { createPopper } from '@popperjs/core';
let hoveredRowId;
function addHoverClass(el) {
  const rows = document.querySelectorAll('.ag-row--action-hover');
  for (let row of rows) {
    var _row$classList;
    (_row$classList = row.classList) === null || _row$classList === void 0 ? void 0 : _row$classList.remove('ag-row--action-hover');
  }
  const rowsHovered = el.querySelectorAll(`[row-id='${hoveredRowId}']`);
  for (let row of rowsHovered) {
    var _row$classList2;
    (_row$classList2 = row.classList) === null || _row$classList2 === void 0 ? void 0 : _row$classList2.add('ag-row--action-hover');
  }
}
export default function BaseCell(cell, params) {
  var _params$node, _params$colDef, _params$context, _params$context2, _params$context3, _params$context4, _params$checkbox, _params$favorite, _params$data, _params$data2, _params$context7, _params$data3;
  if (!params) return null;
  const baseCell = document.createElement('div');
  baseCell.classList.add('w5-cell');
  if (params !== null && params !== void 0 && (_params$node = params.node) !== null && _params$node !== void 0 && _params$node.id) baseCell.setAttribute('data-rowid', params.node.id);
  const data = params.data;
  if (params.customStyles) {
    Object.keys(params.customStyles).forEach(current => {
      baseCell.style[current] = params.customStyles[current];
    });
  }

  // Important the optional chaining because if it's a children row, it has no colDef
  // and it will break
  if (params !== null && params !== void 0 && (_params$colDef = params.colDef) !== null && _params$colDef !== void 0 && _params$colDef.rowDrag) baseCell.classList.add('w5-cell-drag');
  if ((_params$context = params.context) !== null && _params$context !== void 0 && _params$context.useDragCustom && params.column && params.columnApi && ((_params$context2 = params.context) !== null && _params$context2 !== void 0 && _params$context2.canDrag && (_params$context3 = params.context) !== null && _params$context3 !== void 0 && _params$context3.canDrag(data) || !((_params$context4 = params.context) !== null && _params$context4 !== void 0 && _params$context4.canDrag))) {
    const colDef = params.column.colDef;
    const columns = params.columnApi.getColumns();
    if (colDef.colId === columns[0].colId) {
      const customDragger = document.createElement('div');
      customDragger.classList.add('w5-cell__custom-dragger');
      const dragger = `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M0 18c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4-6c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm0-6c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm1 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4-6c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm0-6c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z" fill="var(--actionMinor-400)" />
                            </svg>`;
      customDragger.innerHTML = dragger;
      baseCell.appendChild(customDragger);
    }
  }
  addCellClasses(baseCell, params);
  addChildrenCellClasses(baseCell, params);
  if (params !== null && params !== void 0 && (_params$checkbox = params.checkbox) !== null && _params$checkbox !== void 0 && _params$checkbox.onClick) {
    const checkbox = CellCheckbox(params);
    checkbox && baseCell.appendChild(checkbox);
  }
  if (params !== null && params !== void 0 && (_params$favorite = params.favorite) !== null && _params$favorite !== void 0 && _params$favorite.onClick) {
    const favorite = CellFavorite(params);
    favorite && baseCell.appendChild(favorite);
  }
  if (params !== null && params !== void 0 && params.withGroup) {
    const chevron = GroupChevron(params);
    chevron && baseCell.appendChild(chevron);
  }
  let finalCell;
  if (params !== null && params !== void 0 && (_params$data = params.data) !== null && _params$data !== void 0 && _params$data.isFullWidth) finalCell = cell;else if (params !== null && params !== void 0 && params.childrenParams && params !== null && params !== void 0 && (_params$data2 = params.data) !== null && _params$data2 !== void 0 && _params$data2.isChildren) {
    finalCell = Children(params);
    if (params !== null && params !== void 0 && params.withGroup) {
      finalCell.classList.add('w5-cell__children-first-cell');
    } else {
      finalCell.classList.add('w5-cell__children');
    }
  } else finalCell = cell;
  addCellOnClick(baseCell, params);
  addChildrenCellOnClick(baseCell, params);
  addNonClickCellHoverLink(baseCell, params);
  if (params !== null && params !== void 0 && params.getUrl) {
    let linkWrapper;
    if (data !== null && data !== void 0 && data.isChildren) {
      linkWrapper = addChildrenLinkWrapper(finalCell, params, data);
      if (linkWrapper) finalCell = linkWrapper;
    } else {
      linkWrapper = addLinkWrapper(finalCell, params, data);
      if (linkWrapper) finalCell = linkWrapper;
    }
  }
  if (finalCell) baseCell.appendChild(finalCell);
  function isValidValue(value) {
    if (value === undefined || value === null || value === '') return false;
    return true;
  }
  if (params.useTooltip && (params.tooltipKey && isValidValue(data === null || data === void 0 ? void 0 : data[params.tooltipKey]) || !params.tooltipKey && isValidValue(params.value))) {
    var _params$context5, _params$context6;
    const element = params !== null && params !== void 0 && (_params$context5 = params.context) !== null && _params$context5 !== void 0 && _params$context5.tableId ? document.querySelector(`#${params === null || params === void 0 ? void 0 : (_params$context6 = params.context) === null || _params$context6 === void 0 ? void 0 : _params$context6.tableId}`) : document;
    const tooltip = element.querySelector('.w5-tooltip');
    let popperInstance = null;
    baseCell.addEventListener('mouseover', () => {
      tooltip.style.display = 'block';
      tooltip.firstElementChild.innerText = (params === null || params === void 0 ? void 0 : params.tooltipValue) && (params === null || params === void 0 ? void 0 : params.tooltipValue(params.value)) || data[params.tooltipKey] || params.value;
      let placement = 'top-start';
      if (params.align === 'right') placement = 'top-end';
      if (params.align === 'center') placement = 'top';
      createPopper(baseCell, tooltip, {
        placement,
        modifiers: [{
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }]
      });
    });
    baseCell.addEventListener('mouseout', () => {
      tooltip.style.display = 'none';
      if (popperInstance) {
        popperInstance.destroy();
        popperInstance = null;
      }
    });
  }
  if (params !== null && params !== void 0 && (_params$context7 = params.context) !== null && _params$context7 !== void 0 && _params$context7.hasActions && !(params !== null && params !== void 0 && (_params$data3 = params.data) !== null && _params$data3 !== void 0 && _params$data3.isFullWidth)) {
    controlActionsDisplay(baseCell, params);
  }
  return baseCell;
}
function addCellClasses(baseCell, params) {
  var _params$data4, _params$data5;
  if (!(params !== null && params !== void 0 && (_params$data4 = params.data) !== null && _params$data4 !== void 0 && _params$data4.isChildren) || params !== null && params !== void 0 && (_params$data5 = params.data) !== null && _params$data5 !== void 0 && _params$data5.isChildren && !(params !== null && params !== void 0 && params.childrenParams)) {
    if (params !== null && params !== void 0 && params.bold) baseCell.classList.add('w5-cell--bold');
    if (params !== null && params !== void 0 && params.link) baseCell.classList.add('w5-cell--link');
    if (params !== null && params !== void 0 && params.align) baseCell.classList.add(`w5-cell--align-${params.align}`);
  }
}
function addChildrenCellClasses(baseCell, params) {
  var _params$data6;
  if (params !== null && params !== void 0 && (_params$data6 = params.data) !== null && _params$data6 !== void 0 && _params$data6.isChildren) {
    var _params$childrenParam, _params$childrenParam2, _params$childrenParam3;
    if (params !== null && params !== void 0 && (_params$childrenParam = params.childrenParams) !== null && _params$childrenParam !== void 0 && _params$childrenParam.bold) baseCell.classList.add('w5-cell--bold');
    if (params !== null && params !== void 0 && (_params$childrenParam2 = params.childrenParams) !== null && _params$childrenParam2 !== void 0 && _params$childrenParam2.link) baseCell.classList.add('w5-cell--link');
    if (params !== null && params !== void 0 && (_params$childrenParam3 = params.childrenParams) !== null && _params$childrenParam3 !== void 0 && _params$childrenParam3.align) baseCell.classList.add(`w5-cell--align-${params.childrenParams.align}`);
  }
}
function addCellOnClick(baseCell, params) {
  var _params$data7;
  if ((!(params !== null && params !== void 0 && params.getUrl) || params !== null && params !== void 0 && params.getUrl && params !== null && params !== void 0 && params.forceUrl) && baseCell && params !== null && params !== void 0 && params.onClick && !(params !== null && params !== void 0 && (_params$data7 = params.data) !== null && _params$data7 !== void 0 && _params$data7.isChildren)) {
    baseCell.classList.add('w5-cell--click');
    if (params.hoverLink) {
      baseCell.classList.add('w5-cell-click--with-hover');
    }
    baseCell.addEventListener('click', event => {
      event.stopPropagation();
      if (params !== null && params !== void 0 && params.forceUrl) event.preventDefault();
      params.onClick(params);
    });
  }
}
function addChildrenCellOnClick(baseCell, params) {
  var _params$childrenParam4, _params$data8;
  if (!(params !== null && params !== void 0 && params.getUrl) && baseCell && params !== null && params !== void 0 && (_params$childrenParam4 = params.childrenParams) !== null && _params$childrenParam4 !== void 0 && _params$childrenParam4.onClick && params !== null && params !== void 0 && (_params$data8 = params.data) !== null && _params$data8 !== void 0 && _params$data8.isChildren) {
    baseCell.classList.add('w5-cell--click');
    if (params.hoverLink) {
      baseCell.classList.add('w5-cell-click--with-hover');
    }
    baseCell.addEventListener('click', event => {
      event.stopPropagation();
      params.childrenParams.onClick(params);
    });
  }
}
function addNonClickCellHoverLink(baseCell, params) {
  var _params$childrenParam5;
  if (params.hoverLink && baseCell && !(params !== null && params !== void 0 && params.onClick) && !(params !== null && params !== void 0 && (_params$childrenParam5 = params.childrenParams) !== null && _params$childrenParam5 !== void 0 && _params$childrenParam5.onClick)) {
    baseCell.classList.add('w5-cell--non-click-with-hover');
  }
}
function addLinkWrapper(finalCell, params, data) {
  if ((!(params !== null && params !== void 0 && params.onClick) || params !== null && params !== void 0 && params.onClick && params !== null && params !== void 0 && params.forceUrl) && finalCell && params !== null && params !== void 0 && params.getUrl && data) {
    const linkWrapper = document.createElement('a');
    linkWrapper.classList.add('w5-cell-link-wrapper');
    if (params.hoverLink) {
      linkWrapper.classList.add('w5-cell-link-wrapper--with-hover');
    }
    const url = params.getUrl(data, params.value);
    if (!url) return null;
    linkWrapper.href = url;
    linkWrapper.appendChild(finalCell);
    return linkWrapper;
  }
}
function addChildrenLinkWrapper(finalCell, params, data) {
  if ((!(params !== null && params !== void 0 && params.onClick) || params !== null && params !== void 0 && params.onClick && params !== null && params !== void 0 && params.forceUrl) && finalCell && params !== null && params !== void 0 && params.getUrl && data) {
    const linkWrapper = document.createElement('a');
    linkWrapper.classList.add('w5-cell-link-wrapper');
    if (params.hoverLink) {
      linkWrapper.classList.add('w5-cell-link-wrapper--with-hover');
    }
    const url = params.getUrl(data, params.value);
    if (!url) return null;
    linkWrapper.href = url;
    linkWrapper.appendChild(finalCell);
    return linkWrapper;
  }
}
function controlActionsDisplay(baseCell, params) {
  var _params$context8;
  const node = params.node;
  const tableId = (params === null || params === void 0 ? void 0 : (_params$context8 = params.context) === null || _params$context8 === void 0 ? void 0 : _params$context8.tableId) || '';
  const elementId = tableId ? `w5-actions-component-${tableId}` : 'w5-actions-component';
  function getBodyViewPort() {
    var _params$context9, _params$context9$tabl, _params$context9$tabl2;
    const tableDiv = (params === null || params === void 0 ? void 0 : (_params$context9 = params.context) === null || _params$context9 === void 0 ? void 0 : (_params$context9$tabl = _params$context9.tableRef) === null || _params$context9$tabl === void 0 ? void 0 : (_params$context9$tabl2 = _params$context9$tabl.current) === null || _params$context9$tabl2 === void 0 ? void 0 : _params$context9$tabl2.eGridDiv) || null;
    let bodyViewport = params.api.gridBodyCtrl.eBodyViewport;
    if (tableDiv) {
      bodyViewport = tableDiv.querySelector('.ag-body-viewport');
    }
    return bodyViewport;
  }
  const actionsWrapper = document.getElementById(elementId);
  baseCell.addEventListener('mouseover', () => {
    var _params$eGridCell;
    const bodyViewport = getBodyViewPort();
    const bodyViewportContent = bodyViewport.children;
    let bodyViewportContentChild;
    for (let current of bodyViewportContent) {
      if (current.classList.contains('ag-center-cols-clipper')) {
        bodyViewportContentChild = current;
      }
    }

    // We need to inform about that to add the correct style to prevent overlap the scroll bar.
    const hasScroll = bodyViewportContentChild.offsetHeight > bodyViewport.offsetHeight;
    params.context.getHoveredRowInfo({
      data: params.data,
      hasScroll,
      rowElement: params === null || params === void 0 ? void 0 : (_params$eGridCell = params.eGridCell) === null || _params$eGridCell === void 0 ? void 0 : _params$eGridCell.offsetParent
    });
    hoveredRowId = node.id;
    const scrollTop = bodyViewport.scrollTop;
    const centerElement = 40 - scrollTop;
    const actionsTop = node.rowTop + centerElement;
    if (actionsWrapper) {
      actionsWrapper.style.display = 'block';
      actionsWrapper.style.top = `${actionsTop + 3}px`;
      actionsWrapper.style.height = `${node.rowHeight - 2}px`;
      bodyViewport.onscroll = () => {
        actionsWrapper.style.display = 'none';
      };
    }
  });

  // need all this eventListeners because some overlap the others
  // >> when I'm out from one, can be over the other, and if we don't add
  // >> this three eventListeners may cause undesired flickering in some cases
  baseCell.addEventListener('mouseout', () => {
    if (actionsWrapper) {
      actionsWrapper.style.display = 'none';
    }
  });
  actionsWrapper === null || actionsWrapper === void 0 ? void 0 : actionsWrapper.addEventListener('mouseover', () => {
    if (actionsWrapper) {
      addHoverClass(getBodyViewPort());
      actionsWrapper.style.display = 'block';
    }
    params.context.possibleScrolledRow = node.id;
  });
  actionsWrapper === null || actionsWrapper === void 0 ? void 0 : actionsWrapper.addEventListener('mouseout', () => {
    var _params$context10;
    if (actionsWrapper) {
      actionsWrapper.style.display = 'none';
    }
    if ((params === null || params === void 0 ? void 0 : (_params$context10 = params.context) === null || _params$context10 === void 0 ? void 0 : _params$context10.possibleScrolledRow) === node.id) {
      actionsWrapper === null || actionsWrapper === void 0 ? void 0 : actionsWrapper.scrollTo(0, 0);
      params.context.possibleScrolledRow = '';
    }
  });
  if (actionsWrapper) {
    const wheelEvent = 'onWheel' in actionsWrapper ? 'wheel' : 'mousewheel';
    actionsWrapper === null || actionsWrapper === void 0 ? void 0 : actionsWrapper.addEventListener(wheelEvent, function (event) {
      var _params$context11;
      if ((params === null || params === void 0 ? void 0 : (_params$context11 = params.context) === null || _params$context11 === void 0 ? void 0 : _params$context11.possibleScrolledRow) === node.id) {
        const bodyViewport = getBodyViewPort();
        bodyViewport.scrollBy(event.deltaX, event.deltaY);
        if (actionsWrapper) {
          actionsWrapper.style.display = 'none';
        }
      }
    });
  }
}